// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import API from "api";

import * as ActionTypes from 'constants/ActionTypes';
import * as Actions from "actions";

const querystring = require('querystring');

// Get all system models
function* adminGetSystemModels(action: Object) {
    try {
        const { includeInactive } = action;
        const query = includeInactive ? '?include_inactive=true' : '';
        
        const response = yield API.get(`/admin/system-models${query}`);
        yield put(Actions.adminGetSystemModelsSuccess(response));
    } catch (error) {
        yield put(Actions.adminGetSystemModelsFailure(error));
    }
}

// Create system model
function* adminCreateSystemModel(action: Object) {
    try {
        const { formData, callback } = action;

        const response = yield API.post(
            `/admin/system-models`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        yield put(Actions.adminCreateSystemModelSuccess(response));
        if (callback) callback();
    } catch (error) {
        yield put(Actions.adminCreateSystemModelFailure(error));
    }
}

// Update system model
function* adminUpdateSystemModel(action: Object) {
    try {
        const { modelId, data, callback } = action;

        const response = yield API.put(
            `/admin/system-models/${modelId}`,
            data
        );

        yield put(Actions.adminUpdateSystemModelSuccess(response));
        if (callback) callback();
    } catch (error) {
        yield put(Actions.adminUpdateSystemModelFailure(error));
    }
}

// Update system model image
function* adminUpdateSystemModelImage(action: Object) {
    try {
        const { modelId, formData, callback } = action;

        const response = yield API.post(
            `/admin/system-models/${modelId}/image`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        yield put(Actions.adminUpdateSystemModelImageSuccess(response));
        if (callback) callback();
    } catch (error) {
        yield put(Actions.adminUpdateSystemModelImageFailure(error));
    }
}

// Delete system model
function* adminDeleteSystemModel(action: Object) {
    try {
        const { modelId, callback } = action;

        const response = yield API.delete(`/admin/system-models/${modelId}`);

        yield put(Actions.adminDeleteSystemModelSuccess(modelId));
        if (callback) callback();
    } catch (error) {
        yield put(Actions.adminDeleteSystemModelFailure(error));
    }
}

// Toggle system model active status
function* adminToggleSystemModelActive(action: Object) {
    try {
        const { modelId, isActive, callback } = action;

        const response = yield API.post(
            `/admin/system-models/${modelId}/toggle-active`,
            { is_active: isActive }
        );

        yield put(Actions.adminToggleSystemModelActiveSuccess(modelId, isActive));
        if (callback) callback();
    } catch (error) {
        yield put(Actions.adminToggleSystemModelActiveFailure(error));
    }
}

// Watchers
export default function* adminSystemModelsSaga(): Generator<*, *, *> {
    yield takeLatest(ActionTypes.ADMIN_GET_SYSTEM_MODELS_START, adminGetSystemModels);
    yield takeLatest(ActionTypes.ADMIN_CREATE_SYSTEM_MODEL_START, adminCreateSystemModel);
    yield takeLatest(ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_START, adminUpdateSystemModel);
    yield takeLatest(ActionTypes.ADMIN_UPDATE_SYSTEM_MODEL_IMAGE_START, adminUpdateSystemModelImage);
    yield takeLatest(ActionTypes.ADMIN_DELETE_SYSTEM_MODEL_START, adminDeleteSystemModel);
    yield takeLatest(ActionTypes.ADMIN_TOGGLE_SYSTEM_MODEL_ACTIVE_START, adminToggleSystemModelActive);
}
